const styles = {
    tooltip: {
        marginBottom: '5px',
        marginLeft: '5px'
    },
    numberInput: {
        marginTop: 5
    }
};

export default styles;
